module.exports = __webpack_public_path__ + "static/img/header_bg.5d195d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/portrait/header/header_bg.png
// module id = Wqww
// module chunks = 6